import { ErrorCode, PermissionPath, type Identity } from "core";
import { useIsGranted } from "../../auth/useIsGranted";
import { ErrorPage } from "../../pages/ErrorPage";

interface CanProps {
  userIdentity?: Pick<Identity, "primaryRole">;
  execute: PermissionPath;
  redirect?: ErrorCode;
  fallback?: React.JSX.Element | ErrorCode;
  children: React.JSX.Element;
}

export function Can({
  userIdentity,
  execute,
  redirect,
  fallback,
  children,
}: CanProps) {
  const { hasPermission } = useIsGranted({
    defaultRole: userIdentity?.primaryRole,
    permission: execute,
  });

  if (!hasPermission && redirect) {
    return <ErrorPage code={redirect} />;
  }

  if (!hasPermission && fallback) {
    return fallback;
  }

  return hasPermission ? <>{children}</> : null;
}
